import { render, staticRenderFns } from "./PartnerInvcDialog.vue?vue&type=template&id=2f4baba7&"
import script from "./PartnerInvcDialog.vue?vue&type=script&lang=js&"
export * from "./PartnerInvcDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports